import type { ReactNode } from 'react';
import type { LucideIcon } from 'lucide-react';

export function EtatVide({
  icone: Icone,
  titre,
  children,
}: {
  icone: LucideIcon;
  titre: string;
  children?: ReactNode;
}) {
  return (
    <div className="flex flex-col items-center gap-3 px-6 py-14 text-center">
      <span className="grid size-14 place-items-center rounded-2xl bg-primary-subtle text-primary">
        <Icone className="size-7" aria-hidden />
      </span>
      <h2 className="text-lg font-semibold">{titre}</h2>
      {children ? <div className="max-w-md text-[13px] text-muted">{children}</div> : null}
    </div>
  );
}
